<div class="main-wrapper scrollspy-container">
    <div class="container gap-30 mt-3 ">




        <section class="ppage-payment new-page-payment" *ngIf="isLoading">



            <div class="ytb-car-card-item ">


                <h1 class="section-heading">Please wait while we Get Your Subscribed Information</h1>
                <div class="row">
                    <div class="col-sm-12 col-md-5 col-lg-6">
                        <aside class="sticky-kit sidebar-wrapper carpricecard price-summary">
                            <div class="booking-selection-box ">
                                <div class="content">
                                    <ngx-skeleton-loader count="5" [theme]="{ width: '60%', 'border-radius': '0', height: '15px', 'margin-bottom': '20px' ,'margin-left': '40px'}">
                                    </ngx-skeleton-loader>
                                </div>
                            </div>
                        </aside>
                    </div>
                </div>
                <div class="row">

                    <div class="col-sm-12 col-md-5 col-lg-6">
                        <aside class="sticky-kit sidebar-wrapper carpricecard price-summary">
                            <div class="booking-selection-box ">
                                <div class="content">
                                    <ngx-skeleton-loader count="5" [theme]="{ width: '60%', 'border-radius': '0', height: '15px', 'margin-bottom': '10px' ,'margin-left': '40px'}">
                                    </ngx-skeleton-loader>
                                </div>
                            </div>
                        </aside>
                    </div>
                    <div class="col-sm-12 col-md-5 col-lg-6">
                        <aside class="sticky-kit sidebar-wrapper carpricecard price-summary">
                            <div class="booking-selection-box ">
                                <div class="content">
                                    <ngx-skeleton-loader count="5" [theme]="{ width: '60%', 'border-radius': '0', height: '15px', 'margin-bottom': '10px' ,'margin-left': '40px'}">
                                    </ngx-skeleton-loader>
                                </div>
                            </div>
                        </aside>
                    </div>
                </div>
            </div>



        </section>







        <div class="content-wrapper dashboard-box-mcpn p-b" *ngIf="!isLoading">

            <div class="text-left " style="margin-bottom:0">

                <h4>Unsubscribe</h4>

            </div>
            <div class="hr"></div>

            <div class="col-md-12 myaccount-table ">


                <div class="alert alert-success alert-dismissible mt-2" role="alert" *ngIf="userNotFoundShowSuccess && userNotFoundMessageInfo && userNotFoundMessageInfo.uiSuccessMessge">
                    <button type="button" class="close" data-dismiss="alert">×</button>

                    <div class="alert-message">
                        <span class="alert-icon">
                <i  class="fa fa-check-circle" style="font-size:36px"></i>
            </span>
                        <span class="ml-2" *ngFor="let msg of userNotFoundMessageInfo.uiSuccessMessge"> {{msg}}</span>
                    </div>


                </div>



                <div class="alert alert-success alert-dismissible mt-2" role="alert" *ngIf="userUpdateShowSuccess && userNotFoundMessageInfo && userNotFoundMessageInfo.uiSuccessMessge">
                    <button type="button" class="close" data-dismiss="alert">×</button>

                    <div class="alert-message">
                        <span class="alert-icon">
                <i  class="fa fa-check-circle" style="font-size:36px"></i>
            </span>
                        <span class="ml-2" *ngFor="let msg of userNotFoundMessageInfo.uiSuccessMessge"> {{msg}}</span>
                    </div>


                </div>



                <ng-container *ngIf="userNotFounfShowFail && userNotFoundMessageInfo && userNotFoundMessageInfo.uiErrorMessage">
                    <div class="alert alert-warning alert-dismissible" role="alert">
                        <button type="button" class="close" data-dismiss="alert">×</button>



                        <div class="alert-message">

                            <span class="alert-icon">
                    <i class="fa fa-times text-danger"></i>
                </span>

                            <span class="ml-2" *ngFor="let msg of userNotFoundMessageInfo.uiErrorMessage"> {{msg}}</span>
                        </div>


                    </div>
                    <div class="hr"></div>

                    <div class="row">
                        <div class="col-md-12 text-center">
                            <button type="button" routerLink='/' class="btn btn btn-primary waves-effect waves-light"><span> Home</span></button></div>
                    </div>
                </ng-container>




            </div>

            <!-- <div>
    <div class="row">
        <div class="col-sm-6">
          <div class="form-group">
            <label>Email Address <span class="help-block">*</span></label>
            <input
              formControlName="Email"
              type="text"
              class="form-control form-bg-light"
             
            />
            <span
              class="err-msg"
              *ngIf="
                registrationForm.get('Email').touched &&
                registrationForm.get('Email').hasError('required')
              "
              class="text text-danger"
            >
              Email is required
            </span>

            <span
              class="err-msg"
              *ngIf="
                registrationForm.get('Email').touched &&
                registrationForm.get('Email').hasError('email')
              "
              class="text text-danger"
            >
              Enter valid email address
            </span> -->
            <!-- </div> -->
            <!-- </div> -->

            <!--Phone number-->

            <!-- </div> -->

            <!-- </div> -->
            <!-- <p class="pb-4">To unsubscribe, please check the appropriate box(es). To keep your subscription(s) active, simply close this window.</p> -->

            <ng-container *ngIf="!userNotFounfShowFail && allSubscriptionTypes && allSubscriptionTypes.length>0">
                <form [formGroup]="unsubscribeForm">
                <div class="row">
                    <div class="col-md-2"><label>Email Address </label></div>
                    <div class="col-md-6">
                        <div class="">
                            <input  type="text" class="form-control" formControlName="bookingId" />

                            
                            <span class="err-msg" *ngIf="
                        unsubscribeForm.get('bookingId').touched &&
                        unsubscribeForm.get('bookingId').hasError('required')
                      " class="text text-danger">Email Address is required</span>

                      <span class="err-msg" *ngIf="
                      unsubscribeForm.get('bookingId').touched &&
                      unsubscribeForm.get('bookingId').hasError('email')
                    " class="text text-danger">Please enter a valid email address</span>

                            <span class="err-msg" *ngIf="
                      !unsubscribeForm.get('bookingId')
                        .hasError('required') &&
                        unsubscribeForm.get('bookingId') .hasError('space') &&
                        !unsubscribeForm.get('bookingId')
                          .hasError('pattern')
                    " class="text text-danger">
                    Space not allowed
                </span>


                        </div>
                    </div>
                    <div class="col-md-4"></div>

                </div>
                </form>
                <p class="pb-4">To unsubscribe, please check the appropriate box(es). To keep your subscription(s) active, simply close this window.</p>

                <div *ngFor="let opt of allSubscriptionTypes" class="p-field-checkbox">


                    <p-checkbox class="checkbox-option" [label]="opt.subscription_Name" [value]="opt.subscription_Code" [(ngModel)]="unsubscribedInformation">
                    </p-checkbox>


                </div>




                <div class="hr"></div>

                <div class="row">
                    <div class="col-md-12 text-center">
                        <button type="button" (click)="updateMappingStatus()" buttontext="Markup " class="btn btn btn-secondary waves-effect waves-light"><span> Unsubscribe</span></button>


                        <button type="button" routerLink='/home' class="btn btn btn-primary waves-effect waves-light ml-10"><span> Home</span></button>

                    </div>

                    <!-- <div class="col-md-6 text-center">
                            <button type="button" class="btn btn btn-secondary waves-effect waves-light"><span> Home</span></button>
                        
                        
                        </div> -->
                </div>

            </ng-container>


            <!-- <div class="table-responsive">
        <p-table [value]="allSubscriptionTypes" [(selection)]="unsubscribedInformation" [paginator]="true" [rows]="10">
            <ng-template pTemplate="header">
                <tr>
                    <th>S No</th>
                    <th scope="col" class="text-center">Subscription Name</th>
                    <th scope="col " class="text-center">Un Subscribe</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-subscription let-i="rowIndex">
                <tr>
                    <td class="text-center">
                        {{i+1}} </td>


                    <td class="text-center">
                        {{subscription.subscription_Name}} </td>


                    <td class="text-center">
                        <p-tableCheckbox [value]="subscription.subscription_Code"></p-tableCheckbox>
                    </td>

                </tr>
            </ng-template>
        </p-table>

        <a class="font14 text-underline back-sup-upd-bt font700 pull-right mr-10" aria-expanded="false" (click)="
      updateMappingStatus()
    ">
         Update
    </a>
    </div> -->
        </div>
    </div>
</div>